// GET - /{baseSiteId}/bulletin/my-reports  - returns the list of media 

// POST -  /{baseSiteId}/bulletin/time-stamp - request parameter - codes (string array) 

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
    providedIn: 'root'
})
export class KbMyBulletinService {
    constructor(private http: HttpClient,
        private occService: OccEndpointsService,) { }
    getApi() {
        return this.http.get(this.occService.buildUrl(`bulletin/my-reports`));
    }
    postApi(codes: string[]) {

        let params = new HttpParams();
        codes.forEach(code => {
            params = params.append('codes', code);
        });
        params = params.append('pageName', 'kbReportDownloadPage');
        return this.http.post(
            this.occService.buildUrl('bulletin/time-stamp'),
            null,                     // ✅ body must be null
            { params }
        );

    }
}
